// Presence (fullstack claude/ATTENDEES-SPEC.md § 6): while a page is visible and signed in, its
// Clerk session is touched every 2 minutes, which updates the session's lastActiveAt, the
// attendee directory's activity dots. Clerk doesn't update it while a page just stays open
// (tested 2026-11-03). Same as the fullstack's app/plugins/presenceTouch.client.js.
const TOUCH_MS = 2 * 60 * 1000;

function touch() {
  if (document.hidden) return;
  window.Clerk?.session?.touch?.().catch(() => {});
}

export default {
  install() {
    setInterval(touch, TOUCH_MS);
    document.addEventListener("visibilitychange", touch);
  }
};
